//MMM Do, YYYY translates to Day + ordinal Eg: 1st, 10th etc. Feb 1st, 2023
export const DEFAULT_DATE_FORMAT = "MMM Do, YYYY";
export const DEFAULT_DATE_FORMAT_WITHOUT_YEAR = "MMM Do";
